import { Controller } from "@hotwired/stimulus"
import { renderStreamMessage } from "@hotwired/turbo"

export default class extends Controller {
    static targets = [
        'text',
    ]

    static values = {
        page: String,
        href: String,
        isAdded: Boolean
    }

    connect() {
        
        if (!this.element.hasAttribute('data-action')) {
            this.element.addEventListener("click", this.handleClick.bind(this));
        }
    }

    handleClick(event) {
        this.isAddedValue ? this.remove(event) : this.add(event);
    }

    handleListAction(event, actionType) {
        event.preventDefault();
        const url = event.currentTarget.href;
        const config = {
            add: {
                message: 'Added to My Careers',
                cssClass: 'text-[#707625]'
            },
            remove: {
                message: 'Removed from My Careers',
                cssClass: 'text-[#B83E26]'
            }
        };

        fetch(url, {
            headers: {
                "Accept": "text/vnd.turbo-stream.html"
            }
        }).then(response => {
            if (response.ok) {
                response.text().then(html => {
                    renderStreamMessage(html);
                    
                    if (actionType === 'remove' && window.location.pathname === '/my-careers/') {
                        const careerCard = this.element.closest('[id^="career-card-"]');
                        
                        if (careerCard) {
                            careerCard.style.transition = 'all 0.3s ease';
                            careerCard.style.opacity = '0';
                            careerCard.style.height = careerCard.offsetHeight + 'px';
                            
                            setTimeout(() => {
                                careerCard.style.height = '0';
                                careerCard.style.marginBottom = '0';
                                careerCard.style.paddingTop = '0';
                                careerCard.style.paddingBottom = '0';
                                
                                setTimeout(() => {
                                    careerCard.remove();
                                    
                                    const remainingCards = document.querySelectorAll('[id^="career-card-"]');
                                    if (remainingCards.length === 0) {
                                        window.location.reload();
                                    }
                                }, 300);
                            }, 300);
                        }
                    }
                    
                    const isModal = html.includes('target="show_modal"');
                    if (!isModal) { 
                        document.dispatchEvent(new CustomEvent('show-toast', { 
                            detail: { 
                                message: `${config[actionType].message} <a href="${this.hrefValue}" class="underline ${config[actionType].cssClass}"></a>`, 
                                type: actionType 
                            }
                        }));
                    }
                });
            } else {
                console.error('Request failed with status:', response.status);
            }
        }).catch(error => {
            console.error('Fetch error:', error);
        });
    }

    add(event) {
        this.handleListAction(event, 'add');
    }

    remove(event) {
        this.handleListAction(event, 'remove');
    }
}